import React from 'react';
import { Row, Col, Image } from 'react-bootstrap';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './sectionAcknowledge.css';

import {
  googlePlay,
  appStore,
  appGallery
} from '../../../assets/images';

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

function Acknowledge() {


  return (
    <React.Fragment>
      <div className="header-acknowlege">
        <h1 className="main-text">¡Aprovecha todos los beneficios <br />  de Claro Pay!</h1>
        <p className="desc-text">Crea tu cuenta y descubre lo fácil que es realizar<br /> movimientos desde al app </p>
      </div>
      <div className="content-acknowlege">
        <Row >
          <Col xs={12} className="col-carousel">
            <Carousel
              responsive={responsive}
              showDots={true}
              infinite={true}
              containerClass="carousel-container"
              removeArrowOnDeviceType={["desktop", "tablet", "mobile"]}
              dotListClass="custom-dot-list-style"
              itemClass="carousel-item-padding-10-px"
            >
              <div className="item-general">
                <div><Image src="images/quotation-red.svg" width="50" height="50" /></div>
                <div className="item-description">Le envío dinero a mi mamá mientras estoy hablando por teléfono, y en el momento me confirma que lo recibe."</div>
                <div className="item-author">Mónica González</div>
              </div>
              <div className="item-general">
                <div><Image src="images/quotation-blue.svg" width="50" height="50" /></div>
                <div className="item-description">Me gusta, puedo pagar el teléfono desde mi celular."</div>
                <div className="item-author">Saúl Hernández</div>
              </div>
              <div className="item-general">
                <div><Image src="images/quotation-yellow.svg" width="50" height="50" /></div>
                <div className="item-description">Ya no hay eso de 'mañana te pago'. Ahora mis clientes me mandan el dinero al instante".</div>
                <div className="item-author">Paulina Araiza</div>
              </div>
            </Carousel>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Image src="images/caras.png" className="content-caras" />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <h1 className="title-acknowledge">Tú también únete a Claro Pay</h1>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <p >
              <a target="_blank" rel="noreferrer" href="https://play.google.com/store/apps/details?id=com.globalhitss.claro.pay&referrer=utm_source%3Dlanding%26utm_medium%3Dheropage%26utm_campaign%3Dlanding">
                <Image src={googlePlay} className="icons-store-image" />
              </a>
              &nbsp;
              &nbsp;
              <a target="_blank" rel="noreferrer" href="https://apps.apple.com/mx/app/claro-pay/id1502765283">
                <Image src={appStore} className="icons-store-image" />
              </a>
              &nbsp;
              &nbsp;
              <a target="_blank" rel="noreferrer" href="https://apps.apple.com/mx/app/claro-pay/id1502765283">
                <Image src={appGallery} className="icons-store-image" />
              </a>
            </p>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
}

export default Acknowledge;